import {
  AUTH,
  PROFILE,
  NUMBER,
  FETCH_ACCOUNTS_SUCCESS,
  FETCH_ACCOUNTS_FAILURE,
  FETCH_ACCOUNTS_LOADINGSTART,
  FETCH_ACCOUNTS_LOADINGEND,
  FETCH_ACCOUNTS_PAGI_SUCCESS,
  FETCH_ACCOUNT_SUCCESS,
  FREEZE_ACCOUNT_SUCCESS,
  UNFREEZE_ACCOUNT_SUCCESS,
  DELETEADMIN_ACCOUNT_SUCCESS,
} from "../redux-thunk/ReducerCaseType";
import {
  signUp,
  logIn,
  USERUPDATE,
  HOTELUPDATE,
  VerifyUsers,
  forgetUser,
  ChangeUserPassword,
  CurrentUsermenustylechanged,
  CurrentUserAccountLocked,
  CONECTPRA,
  DISCONECTPRA,
  GETALLACCOUNTS,
  GETACCOUNT,
  GETACCOUNTSEARCH,
  AdminFreezeAccount,
  AdminUnFreezeAccount,
  AdminDeleteAccount,
  USERREFRESHONSOCKET,
  CurrentUserAccountAddSubcribtion,
  CurrentUserAccountDeleteSubcribtion,
  CurrentUserAccountExtendSubcription,
} from "../API/Api";
import { toast } from "react-toastify";
// import CheckSubcriptionEnd from '../MultiUseComponent/CheckSubcriptionEnd/CheckSubcriptionEnd'

export const USERREFRESHONSocket = () => async (dispatch) => {
  const resolveAfter3Sec = new Promise(async (resolve, reject) => {
    try {
      const value = await USERREFRESHONSOCKET();

      if (value.status === 200) {
        setTimeout(resolve(`status:${value.status}:Reload successfully`), 1000);
      }
    } catch (error) {
      if (error.message === "Request failed with status code 500") {
        setTimeout(reject(`status`), 1000);
      } else if (error.message === "Request failed with status code 404") {
        setTimeout(reject(`Failed to reload page.`), 1000);
      }
    }
  });

  toast.promise(resolveAfter3Sec, {
    pending: "loading ...",
    success: {
      render({ data }) {
        return `${data}`;
      },
    },
    error: {
      render({ data }) {
        return `${data}`;
      },
    },
  });
};
export const UpdateUserSch = () => async (dispatch) => {
  try {
    // const value = await UpdateUserSchema();
    // const data = value.data;
    // console.log(data)
  } catch (error) {}
};
// export const UpdateUserTImePeriod = () => async (dispatch) => {
//     try {
//         const value = await ChangeSubcriptionPeriod();
//         const data = value.data;
//         // console.log(data)
//     } catch (error) {

//     }
// }
export const SignUp = (SignupData, history) => async (dispatch) => {
  const resolveAfter3Sec = new Promise(async (resolve, reject) => {
    try {
      // dispatch({ type: 'LOGOUT' });
      const value = await signUp(SignupData);
      const data = value.data;
      if (value.status === 200) {
        setTimeout(resolve(`OTP send successfully`), 1000);
      }
      dispatch({ type: NUMBER, payload: data });
      history("/otp");
    } catch (error) {
      if (error.message === "Request failed with status code 500") {
        setTimeout(
          reject(
            `Failed to send OTP due to a server issue. Please try again later.`
          ),
          1000
        );
      } else if (error.message === "Request failed with status code 404") {
        setTimeout(reject(`User already exists.`), 1000);
      } else if (error.message === "Request failed with status code 405") {
        setTimeout(
          reject(
            `User already exists with the provided details. Please log in instead.`
          ),
          1000
        );
      } else if (error.message === "Request failed with status code 505") {
        setTimeout(reject(`server is down please try again later.`), 1000);
      }
    }
  });

  toast.promise(resolveAfter3Sec, {
    pending: "Sending OTP ...",
    success: {
      render({ data }) {
        return `${data}`;
      },
    },
    error: {
      render({ data }) {
        return `${data}`;
      },
    },
  });
};

export const LogIn =
  (loginData, navigate, CheckSubcriptionEnd) => async (dispatch) => {
    const resolveAfter3Sec = new Promise(async (resolve, reject) => {
      try {
        const value = await logIn(loginData);
        const data = value.data;
        if (value.status === 200) {
          setTimeout(resolve(`Login successful`), 1000);
          const result = data.result;
          const token = data.token;
          // console.log(data);
          dispatch({ type: AUTH, payload: { result, token } });
          await CheckSubcriptionEnd(result);
          navigate("/dashboard/home");
        }
      } catch (error) {
        if (error.message === "Request failed with status code 500") {
          setTimeout(
            reject(
              "Failed to login due to a server issue. Please try again later."
            ),
            1000
          );
        } else if (error.message === "Request failed with status code 403") {
          setTimeout(reject(`Invalid credentials`), 1000);
        } else if (error.message === "Request failed with status code 405") {
          setTimeout(
            reject(
              `User already exists with the provided details. Please sign in instead.`
            ),
            1000
          );
        } else if (error.message === "Request failed with status code 404") {
          setTimeout(
            reject(`You do not have an account please sign up.`),
            1000
          );
        } else {
          setTimeout(reject(`Failed to login.`), 1000);
        }
      }
    });

    toast.promise(resolveAfter3Sec, {
      pending: "Logging in ...",
      success: {
        render({ data }) {
          return `${data}`;
        },
      },
      error: {
        render({ data }) {
          return `${data}`;
        },
      },
    });
  };

export const LOGOUT = (logoutData, navigate) => async (dispatch) => {
  try {
    dispatch(logoutData);
    localStorage.clear();
    navigate("/");
    window.location.reload();
  } catch (error) {}
};

export const UserEdit = (userdata, id, navigate) => async (dispatch) => {
  const resolveAfter3Sec = new Promise(async (resolve, reject) => {
    try {
      const value = await USERUPDATE(userdata, id);
      const data = value.data;

      if (value.status === 200) {
        setTimeout(
          resolve(`status:${value.status}:user account updated successfully`),
          1000
        );
      }
      const result = data;

      dispatch({ type: PROFILE, payload: result });
    } catch (error) {
      if (error.message === "Request failed with status code 500") {
        setTimeout(
          reject(
            `Failed to update user account due to a server issue. Please try again later.`
          ),
          1000
        );
      } else if (error.message === "Request failed with status code 404") {
        setTimeout(reject("User not found."), 1000);
      } else if (error.message === "Request failed with status code 402") {
        setTimeout(reject("User not found."), 1000);
      }
    }
  });

  toast.promise(resolveAfter3Sec, {
    pending: "Edtitin User ....",
    success: {
      render({ data }) {
        return `${data}`;
      },
    },
    error: {
      render({ data }) {
        return `${data}`;
      },
    },
  });
};

export const HotelEdit = (hoteldata, id, navigate) => async (dispatch) => {
  const resolveAfter3Sec = new Promise(async (resolve, reject) => {
    try {
      const value = await HOTELUPDATE(hoteldata, id);
      const data = value.data;

      if (value.status === 200) {
        setTimeout(resolve(`Hotel updated successfully`), 1000);
      }
      const result = data;

      dispatch({ type: PROFILE, payload: result });
    } catch (error) {
      if (error.message === "Request failed with status code 500") {
        setTimeout(
          reject(`Failed to update hotel. Please try again later.`),
          1000
        );
      } else if (error.message === "Request failed with status code 404") {
        setTimeout(reject(`Failed to find hotel`), 1000);
      }
    }
  });

  toast.promise(resolveAfter3Sec, {
    pending: "Edtitin Hotel ....",
    success: {
      render({ data }) {
        return `${data}`;
      },
    },
    error: {
      render({ data }) {
        return `${data}`;
      },
    },
  });
};

export const VerifyData = (otp, navigate) => async (dispatch) => {
  const resolveAfter3Sec = new Promise(async (resolve, reject) => {
    try {
      const value = await VerifyUsers(otp);
      const data = value.data;

      if (value.status === 200) {
        setTimeout(
          resolve(`Created your account successfully now you can login`),
          1000
        );
        navigate("/login");
      } else if (value.status === 201) {
        setTimeout(resolve(`Otp verified successfully`), 1000);
        dispatch({ type: NUMBER, payload: data });
        navigate("/changepassword");
      }
    } catch (error) {
      if (error.message === "Request failed with status code 500") {
        setTimeout(
          reject(
            `Failed to verify OTP due to a server issue. Please try again later.`
          ),
          1000
        );
        navigate("/");
      } else if (error.message === "Request failed with status code 403") {
        setTimeout(reject(`Invalid credentials.`), 1000);
        navigate("/");
      } else if (error.message === "Request failed with status code 405") {
        setTimeout(
          reject(
            `User already exists with the provided details. Please log in instead.`
          ),
          1000
        );
        navigate("/");
      } else if (error.message === "Request failed with status code 400") {
        setTimeout(reject(`OTp is expired.`), 1000);
        navigate("/");
      } else if (error.message === "Request failed with status code 408") {
        setTimeout(
          reject(`OTp not matched. Please check and try again.`),
          1000
        );
      }
    }
  });

  toast.promise(resolveAfter3Sec, {
    pending: "Account Info is pending",
    success: {
      render({ data }) {
        return `${data}`;
      },
    },
    error: {
      render({ data }) {
        return `${data}`;
      },
    },
  });
};

export const FORGETPASSWORD = (number, history) => async (dispatch) => {
  const resolveAfter3Sec = new Promise(async (resolve, reject) => {
    try {
      dispatch({ type: "LOGOUT" });
      const value = await forgetUser(number);
      const data = value.data;

      if (value.status === 200) {
        setTimeout(resolve(`OTP send successfully`), 1000);
      }
      dispatch({ type: NUMBER, payload: data });
      history("/otp");
    } catch (error) {
      if (error.message === "Request failed with status code 500") {
        setTimeout(
          reject(
            `Failed to send OTP due to a server issue. Please try again later.`
          ),
          1000
        );
      } else if (error.message === "Request failed with status code 404") {
        setTimeout(reject(`User already exist`), 1000);
      } else if (error.message === "Request failed with status code 405") {
        setTimeout(
          reject(
            `User already exist with the provided details. Please log in instead.`
          ),
          1000
        );
      }
    }
  });

  toast.promise(resolveAfter3Sec, {
    pending: "Sending OTP ...",
    success: {
      render({ data }) {
        return `${data}`;
      },
    },
    error: {
      render({ data }) {
        return `${data}`;
      },
    },
  });
};

export const CHANGEPASSWORD = (otp, navigate) => async (dispatch) => {
  const resolveAfter3Sec = new Promise(async (resolve, reject) => {
    try {
      const value = await ChangeUserPassword(otp);
      // const data = value.data;

      if (value.status === 200) {
        setTimeout(
          resolve(`status:${value.status}:Password changed successfully`),
          1000
        );
      }

      navigate("/login");
    } catch (error) {
      if (error.message === "Request failed with status code 500") {
        setTimeout(
          reject(
            `Failed to change password due to a server issue. Please try again later.`
          ),
          1000
        );
      } else if (error.message === "Request failed with status code 404") {
        setTimeout(reject(`User already exist`), 1000);
      } else if (error.message === "Request failed with status code 405") {
        setTimeout(
          reject(
            `User already exist with the provided details. Please log in instead.`
          ),
          1000
        );
      }
    }
  });

  toast.promise(resolveAfter3Sec, {
    pending: "Changing Password ...",
    success: {
      render({ data }) {
        return `${data}`;
      },
    },
    error: {
      render({ data }) {
        return `${data}`;
      },
    },
  });
};

export const Usermenustylechanged = (data) => async (dispatch) => {
  const MenuStyleType = data.type;
  const ID = data.ID;

  const resolveAfter3Sec = new Promise(async (resolve, reject) => {
    try {
      // console.log({MenuStyleType:MenuStyleType,ID:ID})
      const value = await CurrentUsermenustylechanged({
        MenuStyleType: MenuStyleType,
        ID: ID,
      });
      const data = value.data;

      if (value.status === 200) {
        setTimeout(resolve(`Product Edited successfully `), 1000);
      }

      const result = data.updatedUser;

      dispatch({ type: PROFILE, payload: result });
    } catch (error) {
      if (error.message === "Request failed with status code 402") {
        setTimeout(reject("status:402 you have not access this task"), 1000);
      } else if (error.message === "Request failed with status code 404") {
        setTimeout(reject(`Failed to change menu style.`), 1000);
      } else if (error.message === "Request failed with status code 408") {
        setTimeout(reject(`Failed to change menu style.`), 1000);
      }
    }
  });

  toast.promise(resolveAfter3Sec, {
    pending: "Changing menu style ...",
    success: {
      render({ data }) {
        return `${data}`;
      },
    },
    error: {
      render({ data }) {
        return `${data}`;
      },
    },
  });
};

export const ConectPunjabRevinewAuth = (PRADATA) => async (dispatch) => {
  const resolveAfter3Sec = new Promise(async (resolve, reject) => {
    try {
      const value = await CONECTPRA(PRADATA);
      const data = value.data;

      if (value.status === 200) {
        setTimeout(
          resolve(`status:${value.status}: User POSID saved successfully `),
          1000
        );
      }

      const result = data.updatedUser;

      dispatch({ type: PROFILE, payload: result });
    } catch (error) {
      if (error.message === "Request failed with status code 402") {
        setTimeout(reject("status:402 you have not access this task"), 1000);
      } else if (error.message === "Request failed with status code 404") {
        setTimeout(reject(`Failed to connect user POSID.`), 1000);
      } else if (error.message === "Request failed with status code 408") {
        setTimeout(reject(`User not found.`), 1000);
      }
    }
  });

  toast.promise(resolveAfter3Sec, {
    pending: "user POSID connecting ...",
    success: {
      render({ data }) {
        return `${data}`;
      },
    },
    error: {
      render({ data }) {
        return `${data}`;
      },
    },
  });
};
export const DisConectPunjabRevinewAuth = (userId) => async (dispatch) => {
  const resolveAfter3Sec = new Promise(async (resolve, reject) => {
    try {
      const value = await DISCONECTPRA(userId);
      const data = value.data;

      if (value.status === 200) {
        setTimeout(
          resolve(`status:${value.status}: POSID Disconnected successfully `),
          1000
        );
      }

      const result = data.updatedUser;

      dispatch({ type: PROFILE, payload: result });
    } catch (error) {
      if (error.message === "Request failed with status code 402") {
        setTimeout(reject("status:402 you have not access this task"), 1000);
      } else if (error.message === "Request failed with status code 404") {
        setTimeout(reject(`Failed to disconnected POSID.`), 1000);
      } else if (error.message === "Request failed with status code 408") {
        setTimeout(reject(`User not found.`), 1000);
      }
    }
  });

  toast.promise(resolveAfter3Sec, {
    pending: "Disconnecting ...",
    success: {
      render({ data }) {
        return `${data}`;
      },
    },
    error: {
      render({ data }) {
        return `${data}`;
      },
    },
  });
};

// UserAccountLocked

export const UserAccountLocked = (user) => async (dispatch) => {
  try {
    const User = user.result;
    const value = await CurrentUserAccountLocked(User);
    const data = value.data;
    const result = data.updatedUser;
    dispatch({ type: PROFILE, payload: result });
  } catch (error) {
    if (error.message == "Request failed with status code 402") {
      toast.error("Failed to load this page. Try again", {
        position: "top-center",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else if (error.message == "Request failed with status code 404") {
      toast.error(`Failed to lock account. Please try again later.`, {
        position: "top-center",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else if (error.message == "Request failed with status code 408") {
      toast.error(`Error while checking user subscription.`, {
        position: "top-center",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  }
};

// FETCH_ACCOUNTS_SUCCESS,FETCH_ACCOUNTS_FAILURE,FETCH_ACCOUNTS_LOADINGSTART,FETCH_ACCOUNTS_LOADINGEND
export const fetchAllAccounts = (page) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_ACCOUNTS_LOADINGSTART });
    const value = await GETALLACCOUNTS(page);
    const data = value.data;

    dispatch({ type: FETCH_ACCOUNTS_SUCCESS, payload: data });
    dispatch({ type: FETCH_ACCOUNTS_LOADINGEND });
  } catch (error) {
    dispatch({ type: FETCH_ACCOUNTS_FAILURE, payload: error.message });
    dispatch({ type: FETCH_ACCOUNTS_LOADINGEND });
  }
};

export const fetchAllAccountsPaginations = (page) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_ACCOUNTS_LOADINGSTART });
    const value = await GETALLACCOUNTS(page);
    const data = value.data;

    dispatch({ type: FETCH_ACCOUNTS_PAGI_SUCCESS, payload: data });
    dispatch({ type: FETCH_ACCOUNTS_LOADINGEND });
  } catch (error) {
    dispatch({ type: FETCH_ACCOUNTS_FAILURE, payload: error.message });
    dispatch({ type: FETCH_ACCOUNTS_LOADINGEND });
  }
};

export const fetchAccount = (id) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_ACCOUNTS_LOADINGSTART });
    const value = await GETACCOUNT(id);
    const data = value.data;

    dispatch({ type: FETCH_ACCOUNT_SUCCESS, payload: data });
    dispatch({ type: FETCH_ACCOUNTS_LOADINGEND });
  } catch (error) {
    dispatch({ type: FETCH_ACCOUNTS_FAILURE, payload: error.message });
    dispatch({ type: FETCH_ACCOUNTS_LOADINGEND });
  }
};

export const fetchAccountSearch = (Searchdata) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_ACCOUNTS_LOADINGSTART });
    const value = await GETACCOUNTSEARCH(Searchdata);
    const data = value.data;
    dispatch({ type: FETCH_ACCOUNTS_SUCCESS, payload: data });
    dispatch({ type: FETCH_ACCOUNTS_LOADINGEND });
  } catch (error) {
    dispatch({ type: FETCH_ACCOUNTS_FAILURE, payload: error.message });
    dispatch({ type: FETCH_ACCOUNTS_LOADINGEND });
  }
};

export const fetchAccountSearchPaginations =
  (Searchdata) => async (dispatch) => {
    try {
      dispatch({ type: FETCH_ACCOUNTS_LOADINGSTART });
      const value = await GETACCOUNTSEARCH(Searchdata);
      const data = value.data;
      dispatch({ type: FETCH_ACCOUNTS_PAGI_SUCCESS, payload: data });
      dispatch({ type: FETCH_ACCOUNTS_LOADINGEND });
    } catch (error) {
      dispatch({ type: FETCH_ACCOUNTS_FAILURE, payload: error.message });
      dispatch({ type: FETCH_ACCOUNTS_LOADINGEND });
    }
  };

export const AdminFreezedAccount = (User) => async (dispatch) => {
  try {
    const value = await AdminFreezeAccount(User);
    const data = value.data;
    const result = data.updatedUser;
    dispatch({ type: FREEZE_ACCOUNT_SUCCESS, payload: result });
  } catch (error) {
    if (error.message == "Request failed with status code 402") {
      toast.error("Failed to load page.Try again", {
        position: "top-center",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else if (error.message == "Request failed with status code 404") {
      toast.error(` Failed to lock account. Please try again later.`, {
        position: "top-center",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else if (error.message == "Request failed with status code 408") {
      toast.error(`Error while checking subscription.`, {
        position: "top-center",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  }
};
export const AdminUnFreezedAccount = (User) => async (dispatch) => {
  try {
    const value = await AdminUnFreezeAccount(User);
    const data = value.data;
    const result = data.updatedUser;
    dispatch({ type: UNFREEZE_ACCOUNT_SUCCESS, payload: result });
  } catch (error) {
    if (error.message == "Request failed with status code 402") {
      toast.error("Failed to load page.Try again.", {
        position: "top-center",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else if (error.message == "Request failed with status code 404") {
      toast.error(`Failed to unlock account. Please try again later.`, {
        position: "top-center",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else if (error.message == "Request failed with status code 408") {
      toast.error(`Error while checking subscription.`, {
        position: "top-center",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  }
};
export const AdminDeletedAccount = (User) => async (dispatch) => {
  try {
    const value = await AdminDeleteAccount(User);
    const data = value.data;
    const result = data.updatedUser;
    dispatch({ type: DELETEADMIN_ACCOUNT_SUCCESS, payload: User.user });
  } catch (error) {
    if (error.message == "Request failed with status code 402") {
      toast.error("Failed to load page.Try again.", {
        position: "top-center",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else if (error.message == "Request failed with status code 404") {
      toast.error(` Failed to delete account. Please try again later.`, {
        position: "top-center",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else if (error.message == "Request failed with status code 408") {
      toast.error(`Error occured while checking user subscription.`, {
        position: "top-center",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  }
};

export const CURRENTUserAccountAddSubcribtion = (User) => async (dispatch) => {
  try {
    const value = await CurrentUserAccountAddSubcribtion(User);
    const data = value.data;
    const result = data.updatedUser;
    dispatch({ type: FREEZE_ACCOUNT_SUCCESS, payload: result });
  } catch (error) {
    if (error.message == "Request failed with status code 402") {
      toast.error("Failed to load page.Try again.", {
        position: "top-center",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else if (error.message == "Request failed with status code 404") {
      toast.error(` Failed to add subscription. Please try again later.`, {
        position: "top-center",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else if (error.message == "Request failed with status code 408") {
      toast.error(`Failed to add subscription.Please try again later.`, {
        position: "top-center",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  }
};

export const CURRENTUserAccountDeleteSubcribtion =
  (User) => async (dispatch) => {
    try {
      const value = await CurrentUserAccountDeleteSubcribtion(User);
      const data = value.data;
      const result = data.updatedUser;
      dispatch({ type: FREEZE_ACCOUNT_SUCCESS, payload: result });
    } catch (error) {
      if (error.message == "Request failed with status code 402") {
        toast.error("Failed to load page.Try again.", {
          position: "top-center",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } else if (error.message == "Request failed with status code 404") {
        toast.error(`Failed to delete subscription. Please try again later.`, {
          position: "top-center",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } else if (error.message == "Request failed with status code 408") {
        toast.error(`Failed to check user subscription.`, {
          position: "top-center",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    }
  };

// Update the CURRENTUserAccountExtendSubcription in AuthAction.js
export const CURRENTUserAccountExtendSubcription =
  (User) => async (dispatch) => {
    try {
      // Create a valid subscription object with all required fields
      const subscriptionData = {
        user: User.user,
        days: User.days,
        subcription: User.subcription || {
          name: "Extended Days",
          price: 0,
          days: User.days,
          discount: 0,
          discountprice: "0", // This is the key fix - make sure this exists
        },
      };

      const value = await CurrentUserAccountExtendSubcription(subscriptionData);
      const data = value.data;
      const result = data.updatedUser;

      dispatch({ type: FREEZE_ACCOUNT_SUCCESS, payload: result });

      toast.success("Subscription extended successfully");
    } catch (error) {
      if (error.message == "Request failed with status code 402") {
        toast.error("Failed to load page.Try again.");
      } else if (error.message == "Request failed with status code 404") {
        toast.error("Failed to extend subscription. Please try again later.");
      } else if (error.message == "Request failed with status code 408") {
        toast.error("Failed to extend subscription. Please try again later.");
      } else {
        toast.error("An error occurred. Please try again.");
      }
    }
  };
// FREEZE_ACCOUNT_SUCCESS,UNFREEZE_ACCOUNT_SUCCESS,DELETEADMIN_ACCOUNT_SUCCESS
